import { render, staticRenderFns } from "./content-public-layout.vue?vue&type=template&id=6b016a38"
import script from "./content-public-layout.vue?vue&type=script&lang=ts"
export * from "./content-public-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports